import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import AcademicCalenderEle from './MPP_curriculumEle'


function Main() {
    return (
      <>
          <Header/>
        <Breadcrumb title="Home" subtitle="Curriculum"/>
          <AcademicCalenderEle />
      </>
    )
  }
  
  export default Main